import { FormikCheckbox } from '@components/form/Checkbox/FormikCheckbox';
import { styled } from '@mui/material';
import React, { memo } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';

import { useUiValue } from '../../../../contexts/UiContext';

const StyledSchedulePropagateBox = styled('div')`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const ResourcesFormPropagateCheckbox = memo(() => {
    const selectedDate = useUiValue('selectedDate');

    return (
        <StyledSchedulePropagateBox>
            <FormikCheckbox
                name="propagate"
                label={
                    <FormattedMessage
                        id="resourcesForm.propagateResources"
                        values={{ propagationDay: <FormattedDate value={selectedDate} weekday="long" /> }}
                    />
                }
            />
        </StyledSchedulePropagateBox>
    );
});
